var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 16 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.addAutoServer.open()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("add")))]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.getList(1)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("search")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          attrs: { data: _vm.tableData, border: "" },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: _vm.$t("idLabel"), width: "60" }
          }),
          _c("el-table-column", {
            attrs: { prop: "game_name", label: _vm.$t("gameIdentifier") }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "date_max_openserver_num",
              label: _vm.$t("dailyMaxOpenServerCount")
            }
          }),
          _c("el-table-column", {
            attrs: { prop: "open_hour", label: _vm.$t("openServerTimeRange") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.not_open_hour_duration &&
                    row.not_open_hour_duration.length
                      ? _c(
                          "div",
                          _vm._l(row.not_open_hour_duration, function(
                            timeRange,
                            index
                          ) {
                            return _c("div", { key: index }, [
                              _vm._v(
                                " " +
                                  _vm._s(timeRange[0]) +
                                  _vm._s(_vm.$t("pointHourSuffix")) +
                                  " - " +
                                  _vm._s(timeRange[1]) +
                                  _vm._s(_vm.$t("pointHourSuffix")) +
                                  " "
                              )
                            ])
                          }),
                          0
                        )
                      : _c("span", [_vm._v("-")])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "open_server_recharge_num",
              label: _vm.$t("rechargePeopleNum")
            }
          }),
          _c("el-table-column", {
            attrs: { prop: "end_time", label: _vm.$t("content") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "viewText",
                        on: {
                          click: function($event) {
                            return _vm.$refs.richTextDetails.open(row)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("view")))]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "is_active", label: _vm.$t("isEnabled") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "text-cursor" }, [
                      row.is_active == 1
                        ? _c("span", { staticStyle: { color: "#409EFF" } }, [
                            _vm._v(_vm._s(_vm.$t("enabled")))
                          ])
                        : _vm._e(),
                      row.is_active == 0
                        ? _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v(_vm._s(_vm.$t("disabled")))
                          ])
                        : _vm._e()
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "open_server_register_num",
              label: _vm.$t("registerCount")
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "force_start_server_days",
              label: _vm.$t("forceOpenServerDays")
            }
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("operation"),
              width: "120",
              align: "center",
              fixed: "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "x-c" }, [
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.$refs.addAutoServer.open(row)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("modify")))]
                      ),
                      _c("div", { staticClass: "controlsBtn-vertical" }),
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.handleDelete(row.id)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("delete")))]
                      )
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("addAutoServer", {
        ref: "addAutoServer",
        on: {
          update: function($event) {
            return _vm.getList(_vm.paramsData.page)
          }
        }
      }),
      _c("richTextDetails", { ref: "richTextDetails" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }